import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { additionalVideos, lineup } from "../../assets/data/lineup";
import { videos, filters } from "../../assets/data/videos";
import { Filter } from "../../components/Filter/filter";
import "./styles.scss";
import { Video, VideoCard } from "./VideoCard/video-card";

const mapEventTypeToTopic = (type: number) => {
 switch (type) {
  case 1:
   return "Highlight";
  case 2:
   return "Stories of iGEM";
  case 3:
   return "Your 2021 Journey";
  case 4:
   return "Imagining the Future";
  case 0:
  default:
   return "";
 }
}

export const Videos = (): JSX.Element => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
 
  // old videos
  const allFilters = filters.filter(filter => filter.type === 0).map((filter) => ({
    name: filter.name,
    color: filter.color,
    isActive: false,
  }));
  const [filtersState, setFiltersState] = useState(allFilters);
  const [activeFilters, setActiveFilters] = useState<string[]>([]);
  const toggleFilter = (filterName: string) => {
    const result = filtersState.map((filter) =>
      filter.name === filterName
        ? { ...filter, isActive: !filter.isActive }
        : filter
    );
    setFiltersState(result);
  };
  useEffect(() => {
    setActiveFilters(
      filtersState
        .filter((filter) => filter.isActive)
        .map((filter) => filter.name)
    );
  }, [filtersState]);
 
  const allTopics = filters.filter(filter => filter.type === 1).map((filter) => ({
   name: filter.name,
   color: filter.color,
   isActive: false,
 }));
 const [topicsState, setTopicsState] = useState(allTopics);
 const [activeTopics, setActiveTopics] = useState<string[]>([]);
 const toggleTopic = (filterName: string) => {
   const result = topicsState.map((filter) =>
     filter.name === filterName
       ? { ...filter, isActive: !filter.isActive }
       : filter
   );
   setTopicsState(result);
 };
 useEffect(() => {
  setActiveTopics(
   topicsState
       .filter((filter) => filter.isActive)
       .map((filter) => filter.name)
   );
 }, [topicsState]);

  const createVideoCard = (video: Video) => (
    <VideoCard video={video} key={video.id} />
  );
  const getFilterState = (filterName: string) =>
   filtersState.find((filter) => filter.name === filterName)?.isActive;
 
   const getTopicState = (filterName: string) =>
   topicsState.find((filter) => filter.name === filterName)?.isActive;

    const previousEvents = [...lineup, ...additionalVideos].sort((a, b) => a.id-b.id).filter(event => event.embedId !== undefined && event.thumbnailId !== undefined).map((event) => ({
     id: event.id,
     type: event.type,
     title: event.title,
    duration: event.duration,
    embedId: event.embedId,
     thumbnailId: event.thumbnailId
   }));
  return (
    <div className="vd">
      <h1>Videos</h1>
      <div className="vd-filters">
        <p>Filter by topic:</p>
        <ul>
          {allTopics.map((filter) => (
            <Filter
              key={filter.name}
              onClick={() => toggleTopic(filter.name)}
              name={filter.name}
              isActive={getTopicState(filter.name)}
              color={filter.color}
            />
          ))}
        </ul>
    </div>
    <div className="vd-videos">
    <h3>Opening Weekend Festival 2021: Livestreamed videos</h3>
        <ul>
      {previousEvents
       .filter((video) => (activeTopics.length === 0 || activeTopics.includes(mapEventTypeToTopic(video.type))))
       .map((video) => createVideoCard(
       {
        ...video,
        videoId: video.embedId ?? '',
        thumbnailPath: `prevThumbnails/${video.thumbnailId ?? ''}.jpg`,
         topic: mapEventTypeToTopic(video.type),
        duration: video.duration ?? 0
       }))}
     </ul>
     {/* <h3>Opening Weekend Festival 2021: Zoom sessions</h3>
     <ul>
      {zoomSessions
       .filter((session) => (activeTopics.length === 0 || activeTopics.includes(mapEventTypeToTopic(session.type))))
       .map((video) => createVideoCard(
       {
        ...video,
        videoId: video.embedId ?? '',
        thumbnailPath: `zoomSessions/${video.thumbnailId ?? ''}.jpg`,
        topic: mapEventTypeToTopic(video.type),
       }))}
     </ul> */}
    </div>
    <div className="vd-filters">
        <p>Filter by topic:</p>
        <ul>
          {allFilters.map((filter) => (
            <Filter
              key={filter.name}
              onClick={() => toggleFilter(filter.name)}
              name={filter.name}
              isActive={getFilterState(filter.name)}
              color={filter.color}
            />
          ))}
        </ul>
    </div>
    <div className="vd-videos">
    <h3>2021: On-Demand Videos</h3>
        <ul>
          {videos
            .filter(
              (video) =>
                video.year === 2021 &&
                (activeFilters.length === 0 ||
                  activeFilters.includes(video.topic))
            )
            .map((video) => createVideoCard({...video, thumbnailPath: `thumbnails/${video.thumbnailPath}`}))}
     </ul>
        <h3>2020: Replay Videos</h3>
        <p>
          These videos were streamed during the 2020 Opening Weekend Festival,
          Global Meetup, and the Giant Jamboree.
        </p>
        <ul>
          {videos
            .filter(
              (video) =>
                video.year === 2020 &&
                (activeFilters.length === 0 ||
                  activeFilters.includes(video.topic))
            )
            .map((video) => createVideoCard({...video, thumbnailPath: `thumbnails/${video.thumbnailPath}`}))}
        </ul>
      </div>
    </div>
  );
};
